export const SPLIT_ORDER_MODAL_CONTENT = {
  DEFAULT: [
    {
      title: 'Split Quantity',
      description:
        'The number of divided (smaller) orders your order will be split into.',
    },
    {
      title: 'Split Range Lot',
      description: 'Sets the min and max lot size for each split order.',
    },
  ],
  SPLIT_METHOD: [
    {
      title: 'Random',
      description:
        'Sets the min and max lot size for each split order. Should not exceed original lot size.',
    },
    {
      title: 'Equal',
      description:
        'The number of divided (smaller) orders your order will be split into. Should not exceed original lot size.',
    },
  ],
};
